import { render, staticRenderFns } from "./SchoolNotifications.vue?vue&type=template&id=96fc2b66&scoped=true"
import script from "./SchoolNotifications.vue?vue&type=script&lang=js"
export * from "./SchoolNotifications.vue?vue&type=script&lang=js"
import style0 from "./SchoolNotifications.vue?vue&type=style&index=0&id=96fc2b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fc2b66",
  null
  
)

export default component.exports